import { useEffect, useRef, useState } from "react";

/**
 * useToastTracker — Tracks the number of visible Sonner toasts via MutationObserver.
 * Returns the current count of active toast elements in the DOM.
 */
export function useToastTracker() {
  const [count, setCount] = useState(0);
  const observerRef = useRef<MutationObserver | null>(null);

  useEffect(() => {
    const updateCount = () => {
      const toasterEl = document.querySelector("[data-sonner-toaster]");
      if (!toasterEl) {
        setCount(0);
        return;
      }
      const toasts = toasterEl.querySelectorAll("[data-sonner-toast]");
      setCount(toasts.length);
    };

    // Initial count
    updateCount();

    // Observe DOM for toast additions/removals
    observerRef.current = new MutationObserver(updateCount);

    // We observe document.body since the toaster may not exist yet
    observerRef.current.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return () => {
      observerRef.current?.disconnect();
    };
  }, []);

  return count;
}
